export function floorToTwoDecimalPlaces(x: number): number {
	return Math.floor(x * 100) / 100;
}
export function floorToThreeDecimalPlaces(x: number): number {
	return Math.floor(x * 1000) / 1000;
}
export function roundToThreeDecimalPlaces(x: number): number {
	return Math.round(x * 1000) / 1000;
}
export function roundToTwoDecimalPlaces(x: number): number {
	return Math.round(x * 100) / 100;
}
export const minQuantity = 0.001;
